<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
    </ion-buttons>
    <ion-title>Dashboard</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <div class="top-informations">
      <div class="value-bigger">
        <span>Total Amount</span>
        <span style="color: black"
          >{{ balance.saldoGanhoDiarioMotorista | currency }}</span
        >
      </div>
      <div class="data-user">
        <div class="ico">
          <ion-img
            src="assets/images/map/car_current_trip.png"
            style="width: 100%"
          />
        </div>
        <h3>{{user.name}}</h3>
      </div>
    </div>
  <div class="informations-complementary">
    <div class="block">
      <ion-icon name="receipt-outline"></ion-icon>
      <h4>Trip Fee</h4>
      <p>{{ balance.saldoEmAberto | currency }}</p>
      <small class="alert" *ngIf="balance.saldoEmAberto > 0"
        ><ion-icon name="alert-circle"></ion-icon> Pending issues</small
      >
    </div>
    <div class="block">
      <ion-icon name="calendar-outline"></ion-icon>
      <h4>Due Date</h4>
      <p>{{ user.dataFimUtilizacao | date: "MMM dd" }}</p>
    </div>
    <div class="block" (click)="payPlatform()">
      <ion-icon name="card-outline"></ion-icon>
      <h4>Pay Now</h4>
      <p>Instant</p>
    </div>
    <div class="block" (click)="goToScheduledTrips()">
      <ion-icon name="megaphone-outline"></ion-icon>
      <h4>In Dispute</h4>
      <p>{{ disputedTripsCount }}</p>
    </div>
  </div>
  <div class="ion-padding">
    <button
      class="button-bigger ew"
      [ngClass]="{ active: isWaiting }"
      (click)="enterQueue()"
    >
      Enter Line
    </button>
  </div>

  <ion-fab vertical="bottom" horizontal="end" slot="fixed">
    <ion-fab-button color="dark" (click)="openMessage()">
      <ion-icon name="chatbox"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
